module.exports = __webpack_public_path__ + "img/node-pool.cc1fdb97.svg";